// extracted by mini-css-extract-plugin
module.exports = {"modal":"CancelModel_modal__1IoXx"};